<template>
	<div class="row dynvibeRow">
		<div class="col-lg-4 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px; margin-bottom: 20px">
				<span class="labelBox">Profiles Growth</span>
				<span class="dynvibeProfilesDetailsValue">
					<span :class="classProfiles">
						{{ profilesEvolution > 0 ? "+" + profilesEvolution : profilesEvolution }}%
						<span class="icon-arrow"> </span>
					</span>
				</span>
			</div>
		</div>
		<div class="col-lg-4 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px; margin-bottom: 20px">
				<span class="labelBox">Posts Growth</span>
				<span class="dynvibeProfilesDetailsValue">
					<span :class="classPosts">
						{{ postsEvolution > 0 ? "+" + postsEvolution : postsEvolution }}%
						<span class="icon-arrow"> </span>
					</span>
				</span>
			</div>
		</div>
		<div class="col-lg-4 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px; margin-bottom: 20px">
				<span class="labelBox">Engagement Growth</span>
				<span class="dynvibeProfilesDetailsValue">
					<span :class="classEngagement">
						{{ engagement > 0 ? "+" + engagement : engagement }}%
						<span class="icon-arrow"> </span>
					</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ExploreModalMetrics",
	props: {
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
		keyword: {
			type: String,
			default: "",
		},
		level: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {
					gte: "",
					lte: "",
				};
			},
		},
		country: {
			type: String,
			default: "",
		},
	},
	components: {},
	data() {
		return {
			rawData: {},
			profilesEvolution: 0,
			postsEvolution: 0,
			engagement: 0,
		};
	},
	computed: {
		classProfiles() {
			if (this.profilesEvolution > 0) {
				return "up";
			} else if (this.profilesEvolution < 0) {
				return "down";
			} else {
				return "neutral";
			}
		},
		classPosts() {
			if (this.postsEvolution > 0) {
				return "up";
			} else if (this.postsEvolution < 0) {
				return "down";
			} else {
				return "neutral";
			}
		},
		classEngagement() {
			if (this.engagement > 0) {
				return "up";
			} else if (this.engagement < 0) {
				return "down";
			} else {
				return "neutral";
			}
		},
	},
	methods: {
		resetData() {
			this.rawData = {};
		},
		loadComponent() {
			this.resetData();

			let params = {
				data: {
					level: this.level,
					mainkeyword: this.keyword,
					sortSize: 1,
				},
				parameters: { ...this.filters },
			};

			if (this.date.gte != "") {
				params.parameters.date = this.date;
			}
			if (this.country != "") {
				params.parameters.country = [this.country];
			}

			this.$axios
				.get(this.$backendUrl + "keymetrics", {
					params: params,
					paramsSerializer: (params) => {
						return this.$Qs.stringify(params, {
							arrayFormat: "brackets",
						});
					},
				})
				.then((response) => {
					if (response.data.results) {
						this.rawData = response.data.results;
						this.computeData();
					}
				});
		},
		computeData() {
			let buckets = this.rawData["date_range"]["buckets"];

			let bucketDocCount0 = buckets[0]["doc_count"];
			let bucketDocCount1 = buckets[1]["doc_count"];
			let bucketProfiles0 = buckets[0]["count"]["value"];
			let bucketProfiles1 = buckets[1]["count"]["value"];
			let bucketImpact0 = buckets[0]["impact_score_fixed"]["value"];
			let bucketImpact1 = buckets[1]["impact_score_fixed"]["value"];

			// prevent division by 0
			bucketDocCount0 = bucketDocCount0 === 0 ? 1 : bucketDocCount0;
			bucketProfiles0 = bucketProfiles0 === 0 ? 1 : bucketProfiles0;
			bucketProfiles1 = bucketProfiles1 === 0 ? 1 : bucketProfiles1;
			bucketImpact0 = bucketImpact0 === 0 ? 1 : bucketImpact0;
			bucketImpact1 = bucketImpact1 === 0 ? 1 : bucketImpact1;

			this.profilesEvolution = Math.round(((bucketProfiles1 - bucketProfiles0) / bucketProfiles0) * 100);
			this.postsEvolution = Math.round(((bucketDocCount1 - bucketDocCount0) / bucketDocCount0) * 100);
			this.engagement = Math.round(((bucketImpact1 - bucketImpact0) / bucketImpact0) * 100);
		},
	},
	watch: {},
};
</script>

<style scoped>
.up {
	color: #33d1cd;
	margin-top: 10px;
}
.down {
	color: #f04b3a;
	margin-top: 10px;
}

.neutral {
	margin-top: 10px;
}
.up > .icon-arrow:before {
	content: "\e92d";
}
.down > .icon-arrow:before {
	content: "\e92c";
}
.dynvibeProfilesDetailsValue {
	font-size: 36px;
}

.labelBox {
	font-size: 16px;
	font-weight: 700;
	color: #757575;
	text-transform: uppercase;
	width: 100%;
}
</style>
